import { IUser } from "../types/auth.types";

/**
 * Get display name for a user
 * Priority: first_name + last_name > given_name + family_name > username > email
 */
export const getDisplayName = (user: IUser | null): string => {
  if (!user) return "User";

  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  }

  if (user.given_name && user.family_name) {
    return `${user.given_name} ${user.family_name}`;
  }

  if (user.username) {
    return user.username;
  }

  return user.email;
};

/**
 * Get initials from user's display name
 * Returns first letter of first two words, or first two letters if single word
 */
export const getInitials = (user: IUser | null): string => {
  const displayName = getDisplayName(user);
  const names = displayName.split(" ");

  if (names.length >= 2) {
    return `${names[0]?.[0] || ""}${names[1]?.[0] || ""}`.toUpperCase();
  }

  return displayName.substring(0, 2).toUpperCase();
};

/**
 * Get user's profile picture URL if available
 */
export const getProfilePicture = (user: IUser | null): string | undefined => {
  return user?.picture || undefined;
};

/**
 * Check if user has a profile picture
 */
export const hasProfilePicture = (user: IUser | null): boolean => {
  return !!user?.picture;
};
